import styled from '@emotion/styled';

const ConnectionItem = styled('li')({
  marginLeft: '6rem',
});

export default ConnectionItem;
